import { Instant } from "js-joda";
import { CaregiverId } from "./messages/ObjectIds";

const TEST_TRIES_PREFIX = "test-tries-";

interface TestTries {
    tries: number;
    createdAt: Instant;
}

export function incrementTestTriesForCaregiver(caregiverId: CaregiverId) {
    const now = Instant.now();
    const triesStr = localStorage.getItem(TEST_TRIES_PREFIX + caregiverId);
    let toSet: TestTries = { tries: 1, createdAt: now};
    if (triesStr !== null) {
        const check: TestTries = JSON.parse(triesStr);
        if (isTestTriesRelevant(check.createdAt, now)) {
            toSet = check;
            toSet.tries++;
        }
    }
    localStorage.setItem(TEST_TRIES_PREFIX + caregiverId, JSON.stringify(toSet));
}

export function getTestTriesForCaregiver(caregiverId: CaregiverId) {
    let toReturn: number = 0;
    const triesStr = localStorage.getItem(TEST_TRIES_PREFIX + caregiverId);
    if (triesStr !== null) {
        const tries: TestTries = JSON.parse(triesStr);
        if (isTestTriesRelevant(tries.createdAt, Instant.now())) {
            toReturn = tries.tries;
        }
    }

    return toReturn;
}

function isTestTriesRelevant(createdAt: Instant, now: Instant): boolean {
    return createdAt > now.minusSeconds(24 * 60 * 60);
}



// WEBPACK FOOTER //
// ./src/LocalStorageManager.ts